{
  "DeleteReminder": "刪除提醒",
  "EditReminder": "編輯提醒",
  "RemindMe15Min": "15 分鐘後再提醒我",
  "RemindMe5Min": "5 分鐘後再提醒我",
  "RemindMe60Min": "一小時後再提醒我",
  "RemindMeTomorrow": "明天再提醒我",
  "SetReminder": "已設定提醒時間: {formattedReminderTime}",
  "Snooze": "再次提醒"
}
